<template>
  <div id="test" @click="showDetail = !showDetail">
    <div
      class="block bg-white rounded-2xl px-4 py-6 border text-cyan-900 text-sm mt-2 mx-4 shadow-lg"
    >
      <div class="grid grid-cols-1 gap-y-4">
        <div>
          <font-awesome-icon icon="circle-user" class="fa-xl text-bgfont" />
          <span class="font-bold mr-1"> نام : </span>
          <span>
            {{ task.customer.customerName }}
            {{ task.customer.customerFamily }}</span
          >
        </div>
        <div>
          <font-awesome-icon icon="shop" class="fa-xl text-bgfont" />
          <span class="font-bold"> نام فروشگاه : </span>
          <span> {{ task.customer.sherkaT_N }} </span>
        </div>
        <div class="flex flex-row">
          <font-awesome-icon icon="passport" class="fa-xl text-bgfont" />
          <span class="font-bold mr-3"> وضعیت : </span>
          <span> {{ task.scheduleStatus.name }} </span>
        </div>
        <div>
          <font-awesome-icon icon="location-dot" class="fa-xl text-bgfont" />
          <span class="font-bold mr-3"> آدرس : </span>
          <span> {{ task.customer.address }} </span>
        </div>
      </div>
      <div
        class="grid grid-cols-1 gap-y-4 mt-4 border border-bgbutton rounded-md p-4"
        v-show="showDetail"
        @click.stop
      >
        <div>
          <font-awesome-icon
            icon="square-phone-flip"
            class="fa-xl text-bgfont"
          />
          <span class="font-bold mr-1"> تلفن : </span>
          <span v-if="task.customer.tel1 !== '' && task.customer.tel2">
            {{ task.customer.tel1 }} / {{ task.customer.tel2 }}
          </span>
          <span v-else-if="task.customer.tel1 !== ''">
            {{ task.customer.tel1 }}
          </span>
          <span v-else-if="task.customer.tel2 !== ''">{{
            task.customer.tel2
          }}</span>
          <span v-else></span>
        </div>
        <div>
          <font-awesome-icon icon="id-badge" class="fa-xl text-bgfont" />
          <span class="font-bold mr-1"> تفصیلی : </span>
          <span> {{ task.customer.customerId }} </span>
        </div>
        <div>
          <font-awesome-icon
            icon="mobile-screen-button"
            class="fa-xl text-bgfont"
          />
          <span class="font-bold mr-1"> همراه : </span>
          <span> {{ task.customer.mobile }} </span>
        </div>
        <div>
          <font-awesome-icon
            icon="money-check-dollar"
            class="fa-xl text-bgfont"
          />
          <span class="font-bold mr-1"> مانده اعتبار : </span>
          <span> {{ task.customer.mandeEtebar }} </span>
        </div>
        <div>
          <font-awesome-icon icon="circle-info" class="fa-xl text-bgfont" />
          <span class="font-bold mr-1"> توضیحات : </span>
          <span> {{ task.description }} </span>
        </div>
        <div
          class="grid grid-cols-3 w-full justify-center items-center text-center mt-2 text-[10px] font-bold gap-x-1"
        >
          <button
            class="bg-bgbutton px-3 py-2 rounded-3xl text-cyan-900 border border-yellow-500 shadow-lg disabled:bg-slate-300 disabled:cursor-no-drop disabled:border disabled:border-slate-400"
            @click="changeStatuse(task.id)"
          >
            تغییروضعیت
          </button>
          <button
            class="bg-bgbutton px-3 py-2 rounded-3xl text-cyan-900 border border-yellow-500 shadow-lg disabled:bg-slate-300 disabled:cursor-no-drop disabled:border disabled:border-slate-400"
            :disabled="
              selectedCustomer != task.customer.customerId && cartCount > 0
            "
            @click="selectAnbar(task.customer.customerId)"
          >
            ثبت سفارش
          </button>
          <button
            class="bg-bgbutton px-3 py-2 rounded-3xl text-cyan-900 border border-yellow-500 shadow-lg disabled:bg-slate-300 disabled:cursor-no-drop disabled:border disabled:border-slate-400"
            @click="getReport(task.customer.customerId)"
            :disabled="cartCount > 0"
          >
            گزارش
          </button>
        </div>
      </div>
    </div>
  </div>
  <transition name="fade">
    <div
      class="fixed h-screen w-screen top-0 bg-gray-500/50 z-30"
      v-if="modalStatus"
      @click="closemodalStatus"
    >
      <div class="bg-white rounded-lg w-3/4 mt-[30%] mx-auto p-4" @click.stop>
        <h1 class="text-center">لطفا وضعیت را انتخاب نمایید</h1>
        <hr class="border-brand/50 my-4" />
        <div dir="rtl" class="flex flex-col justify-center">
          <Select2
            id="status"
            class="select-form w-full"
            :settings="{ width: '100%' }"
            :options="DropStatus"
            @select="ChangeDropStatus($event)"
            placeholder="انتخاب وضعیت"
            :disabled="DropStatus.length <= 0"
          />
          <label class="mt-3">توضیحات</label>
          <textarea
            class="border border-zinc-300 my-2 shadow-sm rounded-md h-32"
            v-model="this.description"
          ></textarea>
          <button
            class="bg-bgbutton p-1 rounded-3xl text-cyan-900 border border-yellow-500"
            @click="updateStatus()"
          >
            ثبت
          </button>
        </div>
      </div>
    </div>
  </transition>
  <transition name="fade">
    <div
      class="fixed h-screen w-screen top-0 bg-gray-500/50 z-30"
      v-if="modalAnbar"
      @click="closemodalAnbar"
    >
      <div
        class="bg-white rounded-lg w-3/4 mt-[30%] mx-auto p-4 h-36"
        @click.stop
      >
        <h1 class="text-center">لطفا انبار را انتخاب نمایید</h1>
        <hr class="border-brand/50 my-4" />
        <div class="flex flex-row justify-center">
          <button
            class="bg-bgbutton px-4 py-2 text-[12px] font-bold rounded-3xl text-cyan-900 disabled:bg-slate-300 disabled:cursor-no-drop disabled:border-slate-500 border border-yellow-500"
            :disabled="Number(this.selectedAnbar) !== 1 && cartCount > 0"
            @click="getAnbar(1)"
          >
            انبارمویرگی
          </button>
          <button
            class="bg-bgbutton px-4 py-2 text-[12px] font-bold rounded-3xl text-cyan-900 mr-1 disabled:bg-slate-300 disabled:cursor-no-drop disabled:border-slate-500 border border-yellow-500"
            :disabled="Number(this.selectedAnbar) != 2 && cartCount > 0"
            @click="getAnbar(2)"
          >
            انبارکلی فروشی
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Select2 from "vue3-select2-component";
import { getStatus, updateStatus } from "@/API/API";
export default {
  name: "TaskCard",
  components: { Select2 },
  props: ["task"],
  data() {
    return {
      showDetail: false,
      DropStatus: [],
      modalAnbar: false,
      modalStatus: false,
      status: [],
      selectedStatus: "",
      sid: "",
      requests: [],
      yesterdaySchedule: [],
      nowSchedule: [],
      tomorrowSchedule: [],
      result: [],
      pagination: {},
      selectedAnbar: "",
    };
  },
  created() {
    this.getStatus();
    this.selectedAnbar = localStorage.getItem("selectedAnbar");
  },
  methods: {
    changeStatuse(id) {
      this.sid = id;
      this.modalStatus = true;
    },
    selectAnbar(id) {
      this.modalAnbar = true;
      localStorage.setItem("selectedCustomer", id);
    },
    async getStatus() {
      (this.DropStatus = []), (this.status = (await getStatus()).data.result);
      this.status.forEach((item) => {
        this.DropStatus.push({
          text: item.scheduleStatusId + " - " + item.name,
          id: item.scheduleStatusId,
        });
      });
    },
    ChangeDropStatus({ id }) {
      this.selectedStatus = "";
      this.selectedStatus = id;
    },
    updateStatus() {
      if (this.description == undefined) this.description = "بدون توضیح";
      updateStatus(this.sid, this.description, this.selectedStatus)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "عملیات باموفقیت انجام شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
            this.modalStatus = false;
            this.$router.go(0);
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "عملیات با شکست مواجه شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
    },
    closemodalStatus() {
      this.modalStatus = false;
    },
    closemodalAnbar() {
      this.modalAnbar = false;
    },
    getAnbar(id) {
      localStorage.setItem("selectedAnbar", id);
      let customer = localStorage.getItem("selectedCustomer");
      this.$router.push(`customer/${customer}/anbar/${id}`);
    },
    // async getTask() {
    //   this.requests = (await schedule(this.q)).data.result;
    //   this.yesterdaySchedule = this.requests.yesterdaySchedule;
    //   this.nowSchedule = this.requests.nowSchedule;
    //   this.tomorrowSchedule = this.requests.tomorrowSchedule;
    //   this.result = this.yesterdaySchedule;
    // },
    getReport(id) {
      this.$router.push(`customer/${id}`);
    },
  },
  computed: {
    cartCount() {
      return this.$store.state.cart.products.length;
    },
    // selectedAnbar() {
    //   return localStorage.getItem("selectedAnbar");
    // },
    selectedCustomer() {
      return localStorage.getItem("selectedCustomer");
    },
  },
};
</script>
<style>
.collapse {
  max-height: 100px;
  transition: all 1s ease-out;
  overflow: hidden;
}

.expand {
  max-height: 1000px;
  transition: all 1s ease-in;
}
</style>
